@import (reference) '../../../constants/spacing.module.less';

.dangerous-goods-tag {
  display: inline-block;
  color: var(--white);
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  border-radius: 4px;
  background-color: var(--grey-500);
  padding: @space-4 @space-8;
}
